<script lang="ts">
  export let datetime: string = '';

  const revisionDateTime = new Date(datetime);
  const formattedDate = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric'
  }).format(revisionDateTime);
</script>

<div>{formattedDate}</div>
